var MuiAppBar = {
    position: 'static',
};
export default MuiAppBar;
//# sourceMappingURL=MuiAppBar.js.map